<template>
  <section class="bill-wrapper">
    <div class="order_list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-checkbox-group v-model="chooseResult" @change="onChooseChange" ref="checkboxGroup">
          <van-cell-group v-for="(item, index) in orders" :key="index" class="order_list__group"
            @click.stop="onSingleChoose(item, index)">
            <!-- 停车场、复选框 -->
            <van-cell :title="item.parkDesc">
              <van-checkbox :disabled="(sameArea==0)?false:sameArea!=item.merchant" icon-size="14px" :name="item"
                @click.stop="onSingleChoose(item, index)" ref="checkBoxes" slot="right-icon" />
            </van-cell>
            <!-- 基础信息 -->
            <van-cell :title="item.cardNumber">
              <div slot="label">
                <div>{{item.entranceDate}}</div>
                <!-- <div>{{item.exitDate}}</div> -->
                <div @click="showDetails(item)">订单详情</div>
              </div>
              <div slot="default" class="order_list__group__price">
                ¥
                <div class="order_list__group__price__integer">
                  {{ item.priceArr[0] }}
                </div>
                .
                {{ item.priceArr[1] }}
                <br>
                <div>{{item.parkingTime}}</div>

              </div>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="order_handler">
      <van-submit-bar safe-area-inset-bottom :price="totalPrice" button-text="确认补缴" button-type="info"
        @submit="onSubmit">
        <van-checkbox :disabled="this.chooseResult.length==0" v-model="checked">同类全选</van-checkbox>
        <span class="order_handler__tip" slot="tip">
          已选
          <span class="order_handler__tip__num">{{ chooseResult.length }}</span>
          条订单
        </span>
      </van-submit-bar>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div style="text-align:center;margin:10px 0">订单详情</div>
        <van-cell title="停车地点" :value="Details.parkDesc" />
        <van-cell title="车牌号码" :value="Details.cardNumber" />
        <van-cell title="入场时间" :value="Details.entranceDate" />
        <van-cell title="停车时长" :value="Details.parkingTime" />
        <van-cell title="应付金额" :value="Details.chargeMoney+'元'" />
        <van-cell title="实付金额" :value="Details.paidMoney+'元'" />
        <van-cell title="欠费金额" :value="Details.unPaidMoney+'元'" />
      </div>
    </van-overlay>
  </section>
</template>

<script>
import { List, CellGroup, Overlay, Checkbox, CheckboxGroup, SubmitBar } from 'vant'
import { getArrearsList } from '@/api/park'
import config from '@/config/index'
import { parseTime, getTimeval, deepClone, getUrlParam } from '@/utils'
export default {
  props: {
    orders: {
      type: Array,
      default () {
        return {}
      }
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [Overlay.name]: Overlay,
    [CheckboxGroup.name]: CheckboxGroup,
    [SubmitBar.name]: SubmitBar
  },
  watch: {
    // 全选反选切换
    checked (val) {
      if (val) {
        for (let i = 0; i < this.orders.length; i++) {
          if (this.sameArea == this.orders[i].merchant) {
            this.$refs.checkBoxes[i].toggle(true)
          }
        }
      } else {
        this.$refs.checkboxGroup.toggleAll(false)
        this.sameArea = 0
      }
    },
    // 监听是否有选择
    chooseResult (val) {
      console.log(val.length)
      if (val.length == 0) {
        this.sameArea = 0
        this.checked = false
      }
    }
  },
  data () {
    return {
      show: false,
      Details: {
        cardNumber: '',
        entranceDate: '',
        exitDate: '',
        priceArr: ['', ''],
        parkingTime: ''
      },
      totalPrice: 0,
      config,
      sameArea: 0,
      muchidStr: '',
      chooseResult: [], //选择项
      loading: false, //加载中。。。
      finished: false, //结束所有状态
      checked: false
    }
  },
  methods: {
    showDetails (item) {
      this.show = true
      this.Details = item
    },
    onLoad () {
      let _this = this
      _this.params.startPage++
      getArrearsList(_this.params).then(res => {
        let data = res.body
        if (data.data.length == 0) {
          _this.finished = true
          _this.loading = true;
          return
        }
        for (let item of data.data) {
          if (typeof item.unPaidMoney === 'number') {
            item.priceArr = item.unPaidMoney.toFixed(2).split('.')
          }
          if (item.entranceDate) {
            let exitDate = item.exitDate || parseTime(new Date())
            item.parkingTime = getTimeval(item.entranceDate, exitDate)
            if (item.parkingTime == '0天0时0分' && _this.config.projectName == 'JNJT') {
              item.parkingTime = '不足1小时'
            }
          }
          _this.orders.push(item)
        }
        _this.finished = false
        _this.loading = false;
        if (_this.orders.length >= data.pageInfo.total) {
          _this.finished = true
          _this.loading = true;
        }
      }).catch(err => {
        _this.$notify({
          type: 'danger',
          message: err
        })
      })

    },
    // 单选
    onSingleChoose (item, index) {

      if (this.sameArea == 0) {
        this.sameArea = item.merchant
      }
      if (this.sameArea == item.merchant) {
        this.$refs.checkBoxes[index].toggle()
      }
    },
    onChooseChange (val) {
      this.totalPrice = val.reduce(function (prev, cur) {
        return cur.unPaidMoney * 100 + prev
      }, 0)
    },
    // 去重
    unique (arr) {
      console.log(arr)
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    //确认补缴
    onSubmit () {
      if (this.chooseResult.length === 0) {
        this.$toast.fail('请选择订单');
        return
      }
      this.chooseResult = this.unique(this.chooseResult)
      console.log(this.chooseResult)
      this.$store.commit('transaction/SET_ARREARS_BILL', this.chooseResult)
      this.$store.commit('transaction/SET_FS_ARREARS_BILL', this.chooseResult)
      let operateId = (this.$route.query.operateId || getUrlParam('operateId'))
      if (operateId) {
        this.$router.push({ name: 'Arrears-Bill-Order', query: { operateId: operateId } })
      } else {
        this.$router.push({ name: 'Arrears-Bill-Order' })
      }

    }
  }
}
</script>


<style lang="scss" scoped>
.bill-wrapper {
  height: 100vh;
  background-color: #f5f5f5;
  /deep/ .van-overlay {
    z-index: 999999;
    background: white;
  }
  .order_list {
    overflow-y: auto;
    padding: 0 8px 0;
    height: calc(100vh - 84px - 1px);

    &__group {
      margin: 5px 0 5px;

      &__price {
        color: #4b62ec;
        font-weight: 500;
        font-size: 12px;

        &__integer {
          display: inline-block;
          font-size: 20px;
          font-family: Avenir-Heavy, PingFang SC, Helvetica Neue, Arial,
            sans-serif;
        }
      }
    }
  }

  .order_handler {
    /deep/ .van-submit-bar__tip,
    &__tip {
      color: #444444;
      background-color: #ffffff;
      border-bottom: 1px solid #f5f5f5;

      &__num {
        color: #f56723;
      }
    }
  }
}
</style>